// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Upload = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="m12.354 6.646-.708.707L9.5 5.207V12h-1V5.207L6.353 7.353l-.707-.707L9 3.293z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.5 11h1v3.5h9V11h1v3.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(Upload);
export default ForwardRef;
